export default {
  // 获取登录背景图，通过二级域名区分
  getLoginInfo: {
    server: '/common/login-info',
    method: 'get',
  },
  // 发送命令
  debugCommand: {
    server: '/common/debug-command',
    method: 'post',
  },
  getVersion: {
    server: `/static/version.json?_=${Math.random()}`,
    method: 'get',
  },
  permissionActionOptions: {
    server: '/constants/permission-action-options',
    method: 'get',
  },
  permissionScopeOptions: {
    server: '/constants/permission-scope-options',
    method: 'get',
  },
  checkSncodeExist: {
    server: '/common/sncode-exist',
    method: 'post',
  },
  checkRegisterExist: {
    server: '/common/register-exist',
    method: 'post',
  },
};
